import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';


// Mute logs/warnings
if (!environment.showConsoleLogs) {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
  // keep errors visible in prod:
  // console.error = console.error.bind(console);
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
